import {
  GatewayWithMachinesViewStateTypes,
  MachinesListCompanyEntry,
} from "@src/types/gateways-with-machines";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GatewaysMachinesState {
  allMachinesListData: Record<string, MachinesListCompanyEntry>;
  connectedGatewaysListData: GatewayWithMachinesViewStateTypes[];
  error: string | null;
  machinesManagerSearchQuery: string;
  machinesManagerSearchTerms: string[];
  machinesManagerShowSearchBar: boolean;
  resultsReady: boolean;
  searchMachinesListData: Record<string, MachinesListCompanyEntry>;
}

const initialState: GatewaysMachinesState = {
  allMachinesListData: {},
  connectedGatewaysListData: [],
  error: null,
  machinesManagerSearchQuery: "",
  machinesManagerSearchTerms: [],
  machinesManagerShowSearchBar: false,
  resultsReady: false,
  searchMachinesListData: {},
};

const gatewaysMachinesSlice = createSlice({
  name: "gatewaysMachines",
  initialState,
  reducers: {
    setAllMachinesWithGatewaysListData(
      state,
      action: PayloadAction<Record<string, MachinesListCompanyEntry>>,
    ) {
      state.allMachinesListData = action.payload;
    },
    setConnectedGatewaysWithMachinesListData(
      state,
      action: PayloadAction<GatewayWithMachinesViewStateTypes[]>,
    ) {
      state.connectedGatewaysListData = action.payload;
    },
    setGatewaysWithMachinesError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setGatewaysWithMachinesResultsReady(state, action: PayloadAction<boolean>) {
      state.resultsReady = action.payload;
    },
    setMachinesWithGatewaysSearchQuery(state, action: PayloadAction<string>) {
      state.machinesManagerSearchQuery = action.payload;
    },
    setMachinesWithGatewaysSearchTerms(state, action: PayloadAction<string[]>) {
      state.machinesManagerSearchTerms = action.payload;
    },
    setMachinesWithGatewaysShowSearchBar(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.machinesManagerShowSearchBar = action.payload;
    },
    setSearchMachinesWithGatewaysListData(
      state,
      action: PayloadAction<Record<string, MachinesListCompanyEntry>>,
    ) {
      state.searchMachinesListData = action.payload;
    },
  },
});

export const {
  setAllMachinesWithGatewaysListData,
  setConnectedGatewaysWithMachinesListData,
  setGatewaysWithMachinesError,
  setGatewaysWithMachinesResultsReady,
  setMachinesWithGatewaysSearchQuery,
  setMachinesWithGatewaysSearchTerms,
  setMachinesWithGatewaysShowSearchBar,
  setSearchMachinesWithGatewaysListData,
} = gatewaysMachinesSlice.actions;

export default gatewaysMachinesSlice.reducer;
